<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3 lg4 offset-lg4>
        <h1>Page Not Found</h1>
        <p>The page you requested does not exist.</p>
      </v-flex>
      <v-flex xs10 offset-xs1 sm4 offset-sm4 lg2 offset-lg5>
        <v-btn block to="/">Go Back Home</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {}
</script>
